import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { cscLightboxThumbnails } from './components/lightbox-thumbnails/lightbox-thumbnails.style.js'


export const cscLightbox = {
  gap: css`var(--csc-lightbox-gap, ${csSpacing.spacing06})`,
  mainImageAspect: css`var(--csc-lightbox-main-image-aspect-ratio, 1 / 1)`,
  videoBackgroundColor: css`var(--csc-lightbox-video-background-color, ${csColorBackground.secondary})`,
  mainImageBackgroundColor: css`var(--csc-lightbox-main-image-background-color, transparent)`,
  mainImagePadding: css`var(--csc-lightbox-main-image-padding, 0)`,
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  .csc-lightbox {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${cscLightbox.gap};
  }

  .csc-lightbox csc-lightbox-thumbnails[alignment='stretch']:not([orientation='vertical']) {
    width: 100%;
  }

  .csc-lightbox.position-left {
    display: grid;
    grid-template-columns: clamp(${cscLightboxThumbnails.minWidth}, 22.5%, ${cscLightboxThumbnails.maxWidth}) 1fr;
    grid-template-rows: 1fr;
    aspect-ratio: ${cscLightbox.mainImageAspect};
    width: 100%;
    align-items: stretch;
    gap: ${cscLightbox.gap};
  }

  .csc-lightbox.position-left .main-image-wrapper {
    grid-column: 2;
    grid-row: 1;
    width: 100%;
    min-width: 0;
    height: 100%;
    min-height: 0;
  }

  .csc-lightbox.position-left .main-image-container {
    aspect-ratio: unset;
    height: 100%;
    width: 100%;
  }

  .csc-lightbox.position-left csc-lightbox-thumbnails[alignment='stretch'] {
    grid-column: 1;
    grid-row: 1;
    width: 100%;
    height: 100%;
    min-height: 0;
    min-width: 0;
  }

  .csc-lightbox csc-lightbox-modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    overflow: visible;
    z-index: 3;
  }

  .main-image-wrapper {
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }

  .main-image-container {
    aspect-ratio: ${cscLightbox.mainImageAspect};
    overflow: hidden;
    position: relative;
    background: ${cscLightbox.mainImageBackgroundColor};
  }

  .main-image-container csc-lightbox-media {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    inset: 0;
  }

  .main-image-container:not(.is-video) csc-lightbox-media {
    box-sizing: border-box;
    padding: ${cscLightbox.mainImagePadding};
  }

  .main-image-container.is-video {
    background: ${cscLightbox.videoBackgroundColor};
  }

  .video-click-overlay {
    position: absolute;
    inset: 0;
    
    cursor: pointer;
  }

  .image-enter {
    animation: slideIn 0.35s ease-out forwards;
  }

  .image-exit {
    animation: slideOut 0.35s ease-out forwards;
  }

  .slide-left .image-enter {
    animation-name: slideInFromRight;
  }

  .slide-left .image-exit {
    animation-name: slideOutToLeft;
  }

  .slide-right .image-enter {
    animation-name: slideInFromLeft;
  }

  .slide-right .image-exit {
    animation-name: slideOutToRight;
  }

  @keyframes slideInFromRight {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  @keyframes slideOutToLeft {
    from { transform: translateX(0); opacity: 1; }
    to { transform: translateX(-100%); opacity: 0; }
  }

  @keyframes slideInFromLeft {
    from { transform: translateX(-100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  @keyframes slideOutToRight {
    from { transform: translateX(0); opacity: 1; }
    to { transform: translateX(100%); opacity: 0; }
  }

  .badge-group {
    position: absolute;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
  }

  .badge-group.position-top-left {
    top: ${csSpacing.spacing05};
    left: ${csSpacing.spacing05};
  }

  .badge-group.position-top-right {
    top: ${csSpacing.spacing05};
    right: ${csSpacing.spacing05};
    align-items: flex-end;
  }

  .badge-group.position-bottom-left {
    bottom: ${csSpacing.spacing05};
    left: ${csSpacing.spacing05};
  }

  .badge-group.position-bottom-right {
    bottom: ${csSpacing.spacing05};
    right: ${csSpacing.spacing05};
    align-items: flex-end;
  }

  .gallery-controls {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${csSpacing.spacing05};
    pointer-events: none;
    z-index: 2;
    box-sizing: border-box;
  }

  .gallery-controls cse-icon-button {
    pointer-events: auto;
    transition: opacity ${csTransition.duration} ${csTransition.timingFunction};
  }

  .enlarge-chip {
    position: absolute;
    bottom: ${csSpacing.spacing05};
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    min-height: 32px;

    
  }
`
